import { BulbOutlined } from "@ant-design/icons";
import { Prompts } from "@ant-design/x";

export default function ChatPrompt({ handleSend }) {
  const DEFAULT_ITEMS = [
    {
      key: "1",
      icon: <BulbOutlined />,
      label: "Device Status Overview",
      description:
        "Check which devices are online, offline, or in error state.",
      content: "Show me the current status of all my devices.",
    },
    {
      key: "2",
      icon: <BulbOutlined />,
      label: "Energy Consumption This Month",
      description: "Total energy consumed per device for the current month.",
      content:
        "Show me the total energy consumption all my devices this month.",
    },
    {
      key: "3",
      icon: <BulbOutlined />,
      label: "Maximum Demand",
      description: "Find the maximum demand recorded at site.",
      content: "What is the maximum demand for my site this month?",
    },
    // {
    //   key: "4",
    //   icon: <BulbOutlined />,
    //   label: "Peak vs Off-Peak Usage",
    //   description: "Compare energy usage during peak and off-peak hours.",
    //   content:
    //     "Compare peak and off-peak energy usage for my devices this month.",
    // },
    {
      key: "5",
      icon: <BulbOutlined />,
      label: "Live Parameter Readings",
      description: "View real-time parameter values for devices.",
      content:
        "Show me the current real-time parameter readings for my devices.",
    },
  ];

  function onPromptClick(value) {
    let promptContent = value["data"].content;
    handleSend(promptContent, []);
  }

  return (
    <Prompts
      title={"Command Questions"}
      items={DEFAULT_ITEMS}
      wrap
      style={{ width: "80%" }}
      onItemClick={(value) => onPromptClick(value)}
    />
  );
}
